import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { eliminarUsuario } from '../../actions/usuarios';

const EliminarUsuario = ({ usuario, handleCerrar }) => {

    const dispatch = useDispatch();

    const [eliminarModal, setEliminarModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    useEffect(() => {
        setEliminarModal(usuario ? true : false);
    }, [usuario]);

    const handleProcesar = async () => {
        setStatusProcesar(true);
        await dispatch(eliminarUsuario(usuario._id));
        setStatusProcesar(false);
        handleCerrar();
    };

    const handleClose = () => {
        setEliminarModal(false);
        handleCerrar();
    };

    return (
        <Modal show={eliminarModal} backdrop="static" centered onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Eliminar usuario</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>¿Deseas eliminar al usuario <b>{usuario ? `${usuario.nombre || ''} ${usuario.apellido_paterno || ''} ${usuario.apellido_materno || ''}` : ''}</b>? Esta acción no se puede deshacer.</p>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-secondary" onClick={handleClose} disabled={statusProcesar}>
                    No
                </button>
                {
                    statusProcesar
                        ? <button className="btn btn-danger" disabled><span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span> Sí</button>
                        : <button className="btn btn-danger" onClick={handleProcesar}>Sí</button>
                }
            </Modal.Footer>
        </Modal>
    );
};

export default EliminarUsuario;
